// import io from 'socket.io'
import io from 'io'
import DIC from '@/index/dictionary/index.js'
import Vue from 'vue'
let $io = {
  socket: undefined,
  init () {
    let adminId = Vue.prototype.$session.get('adminId')
    if (adminId !== undefined) {
      this.socket = io.connect(DIC.PUSH)
      this.socket.on('connect', res => {
        console.warn('connect')
      })
      /**/
      this.socket.on('mtea_store_admin#' + adminId, res => {
        let pushRes = res
        let pushData = res.body
        Vue.prototype.$axios.get('/mtea/store/admin/msg/unReadCount', { params: {} }).then(res => {
          let count = _.reduce(res, (memo, item) => { return memo + item.count }, 0)
          Vue.prototype.$bus.$emit('menuDotShow', { menu: { path: '/operate/msg/tabs' }, count: count })
        })
        // console.log('pushData', pushData)
        Vue.prototype.$notify.info({
          title: '消息',
          message: pushData
        })
        Vue.prototype.$alarm.play()
      })
    }
  }
}
Vue.prototype.$io = $io
